__turbopack_context__.v({
  "className": "playfair_display_fcffd8a8-module__0VZi6q__className",
});
